module.exports = __webpack_public_path__ + "img/nbus_box_1.5de3ee72.jpg";